module.exports = __webpack_public_path__ + "img/image 38.5a067ae4.png";